import React, { Component } from 'react'
import {connect} from 'react-redux'
import {UserNav, Button, User as UserShape, UploadFile, Field, Error, Success, Load} from './../../../components'
import {UserInformationStyle} from './../../../styles'
import { updateProfile, fetchPage, postFile } from './../../../services/ApiController'
import { logOut as SlogOut, updateProfilePicture } from './../../../store/actions/Session'


class User extends Component {

  state = {
    editPass: false,
    editStore: false,
    token: '',
    formData: {},
    error: '',
    success: '',
    storeName: '',
    storeID: '',
    stores: [],
    picture: '',
    pictReady: false,
  }

  componentDidMount () {
    this.getStore()
  }

  getStore = async () => {
    await fetchPage('/change-store').then((data) => {
      if (data.success) { 
       this.setState({ stores: data.stores, storeName: data.stores[this.props.store], storeID: this.props.store, picture: this.props.picture, pictReady: true })
      }
    }).catch(() => {
      console.log('Oops something wrong with the store')
    })
  }

  changeStore = async () => {
    await this.setState({ editStore: true })
  }

  changePassword = async () => {
    await this.setState({ editPass: true })
  }

  requestSore = async () => {
    await updateProfile(this.props.urls.updateStore, {store: this.state.storeID }).then((data) => {
      if (data.success) this.setState({ editStore: false, storeName: this.state.stores[this.state.storeID]})
    }).catch((e) => {
      console.log('Whooops something wrong with user picture')
    })
  }

  requestPassword = async () => {
    const {formData} = this.state 
    if (formData['changePassword[plainPassword][first]'] === formData['changePassword[plainPassword][second]']) {
      await updateProfile(this.props.form.action, this.state.formData).then((data) => {
        if (data.error && data.error !== '') this.setState({error: data.error})
        if (data.success && data.success !== '') {
          this.setState({success: 'Password changed', editPass: false})
        }
      }).catch((err) => {
        console.log(err)
      })
    } else {
      await this.setState({ error: 'You must have the same password'})
    }
  }

  requestUpload = async (picture) => {
    const formData = new FormData()
    formData.append('file', picture)

    await postFile(this.props.urls.updatePicture, formData).then((data) => {
      if (data.success) { 
        this.setState({ picture: data.picture })
        this.props.setPicture(data.picture)
      }
    }).catch((e) => {
      console.log('Whooops something wrong with user picture', e)
    })
  }

  requestLogout = async () => {
    await this.props.logOut()
  }

  handlerChangeStore = (e) => {
    this.setState({ storeID:  e.currentTarget.value})
  }

  addFormData = (data) => {
    const { formData } = this.state
    const row = []
    row[data.key] = data.value
    this.setState({ formData: { ...formData, ...row} })
  }

  render () {
    const { role, username, form } = this.props
    const { editPass, editStore, error, success, storeName, stores, storeID, pictReady, picture } = this.state
    return (
      <div className={`${UserInformationStyle( picture !== '' ? picture : this.props.picture, pictReady ) } user-information`}>
        <UserNav />
        <div className="user-form-edit">
          <div className="flex">
            <div className="user-form-edit-picture">
              <div className="picture"> <Load width={24} height={24} /> </div>
              <form ref={(form) => this.uploadForm = form}>
                <UploadFile accept=".jpg,.png,.gif,.jpeg" value={picture} uploadCallback={this.requestUpload} name="upload-profile" id="upload-profile-picture" > Edit Profile </UploadFile>
              </form>
            </div>
            <div className="user-form-edit-information">
              <div className="flex form-row">
                <div className="label">Name</div>
                <div className="information">{ username }</div>
              </div>
              { /* <div className="flex form-row">
                <div className="label">Role</div>
                <div className="information"> {role} </div>
              </div>
              <div className="flex items-center form-row">
                <div className="label">Current Store</div>
                <div className="information">
                  { 
                    editStore ? (
                      <select onChange={this.handlerChangeStore} value={storeID} >
                       {
                         Object.keys(stores).map((id) => (
                          <option value={id} key={id}>{stores[id]}</option>
                         ))
                       } 
                      </select>
                    ) : storeName 
                  }
                </div>
                <div className="button">
                {
                  editStore ? (
                    <Button type='button' onCallback={this.requestSore}> 
                      Valid 
                    </Button>
                  ) : (
                    <Button type='button' onCallback={this.changeStore}> 
                      Edit 
                    </Button>
                  )
                }
                </div>
              </div> */ }
              <div className="flex form-row pass-row">
                <div className="label">Password</div>
                <div className="information">
                  {
                    editPass ? (
                      <div>
                        <Field type="password" onChange={this.addFormData} id={form.fields.oldPassword.id} name={form.fields.oldPassword.name} value='' > Old password </Field>               
                        <Field type="password" onChange={this.addFormData}  id={`${form.fields.plainPassword.id}$first`} name={`${form.fields.plainPassword.name}[first]`} value=''>New Password </Field>
                        <Field type="password" onChange={this.addFormData} id={`${form.fields.plainPassword.id}$second`} name={`${form.fields.plainPassword.name}[second]`} value=''>Confirm new Password </Field>
                        <Field type="hidden" onChange={this.addFormData} id={form.fields['_token'].id} name={form.fields['_token'].name} value={form.fields['_token'].value} ></Field>
                        { error && <div className="alert"><Error className="error">{error}</Error></div> }
                        { success !== '' && <div className="alert"><Success >{success}</Success></div> }
                      </div>
                      ) : <input type="password" name="password" disabled value="toto1234" />

                  }
                </div>
                <div className="button">
                {
                  editPass ? (
                    <Button type='button' className="btn btn-edit btn-request-pass" onCallback={this.requestPassword}> 
                      Valid 
                    </Button>
                  ) : (
                    <Button type='button' className="btn btn-edit" onCallback={this.changePassword}> 
                      Edit 
                    </Button>
                  )
                }
                </div>
              </div>
              <Button type='button' className="btn btn-logout logout-btn" onCallback={this.requestLogout}> 
                <UserShape width={24} height={24} /> Log out 
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    username: Session.username,
    role: Session.role,
    urls: Session.urls,
    form: Session.forgotForm,
    store: Session.store,
    picture: Session.picture
  }),
  dispatch => ({
    setPicture: (file) => dispatch(updateProfilePicture(file)),
    logOut: () => dispatch(SlogOut())
  })
)(User)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/User.js